<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2b"><a id="page_vii"></a>CONTENTS</h2>
<p class="toc-entry1"><a href="#/xhtml/frontmatter01"><em>Acknowledgments</em></a></p>
<p class="toc-entry1"><a href="#/xhtml/frontmatter02">Introduction: Revolutionary Rupture and National Stability</a></p>
<p class="toc-entryc"><span href="#/xhtml/part01" title="Link target outside of Sample"><span class="small">PART ONE</span></span></p>
<p class="toc-entry"><span href="#/xhtml/chapter01" title="Link target outside of Sample">1 <em>Kino-Nedelia,</em> Early Documentary, and the Performance<br/>of a New Collective, 1917–1921</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter02" title="Link target outside of Sample">2 A Cinema Looking for People: The Individual and the Collective in Immediate Post-Revolutionary Cuban Nonfiction Film</span></p>
<p class="toc-entryc"><span href="#/xhtml/part02" title="Link target outside of Sample"><span class="small">PART TWO</span></span></p>
<p class="toc-entry"><span href="#/xhtml/chapter03" title="Link target outside of Sample">3 The Dialectics of Thought and Vision in the Films of Dziga Vertov, 1922–1927</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter04" title="Link target outside of Sample">4 (Non)Alignments and the New Revolutionary Man</span></p>
<p class="toc-entryc"><span href="#/xhtml/part03" title="Link target outside of Sample"><span class="small">PART THREE</span></span></p>
<p class="toc-entry"><span href="#/xhtml/chapter05" title="Link target outside of Sample">5 Esfir Shub, Factography, and the New Documentary Historiography</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter06" title="Link target outside of Sample">6 The Object of Revolutionary History: Santiago Álvarez’s Commemorative Newsreels and Chronicle Documentaries, 1972–1974</span></p>
<p class="toc-entry1"><span href="#/xhtml/backmatter01" title="Link target outside of Sample"><em>Notes</em></span></p>
<p class="toc-entry1a"><span href="#/xhtml/backmatter02" title="Link target outside of Sample"><em>Bibliography</em></span></p>
<p class="toc-entry1a"><span href="#/xhtml/backmatter03" title="Link target outside of Sample"><em>Filmography</em></span></p>
<p class="toc-entry1a"><span href="#/xhtml/backmatter04" title="Link target outside of Sample"><em>Index</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?977654f2